import type { ReactNode } from 'react'
import { AppNav, type AppTab } from './AppNav'

/**
 * Standard screen frame: paper background, full-height flex column, and a
 * persistent bottom nav. Every signed-in screen uses this so the nav is
 * present consistently — the exceptions are the record wizard (a focused
 * step flow) and the unauthenticated/public pages (sign-in, public share).
 *
 * `active` highlights a tab; omit it on drill-down screens that aren't a
 * top-level destination.
 */
export const ScreenShell = ({
  active,
  children,
}: {
  active?: AppTab
  children: ReactNode
}) => (
  <div className="paper" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
    <div style={{ flex: 1, paddingBottom: 24 }}>{children}</div>
    <AppNav active={active} />
  </div>
)
